import React from 'react';

const Checkbox = ({ label, checked, onChange }: any) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      fontSize: 14,
      color: '#161D1F',
      marginBottom: 16
    }}
  >
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        fontWeight: 400
      }}
    >
      <input
        data-testid="checkbox-input"
        style={{
          visibility: 'inherit',
          accentColor: '#745EF6',
          width: 16,
          height: 16,
          marginRight: 8
        }}
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      {label}
    </label>
  </div>
);

export default Checkbox;
